<template>
    <b-card no-body>
        
        <b-modal id="description" :title="approveOrRejectData.title" no-close-on-esc no-close-on-backdrop >
            <div class="row">
                <div class="col-12">
                    <label class="form-label">Açıklama</label>
                    <textarea class="form-control" v-model="approveOrRejectData.description" rows="3" placeholder="Açıklama"></textarea>
                </div>
            </div>
            <template #modal-footer><v-executer :loading="approveOrRejecting" :dsiabled="!approveOrRejectData.description" :action="approveOrReject">Gönder</v-executer></template>
        </b-modal>


        <b-modal id="view-traffic-fine-detail-modal" size="lg" :title="`Trafik Cezası Detayları - ${selectedTrafficFineDetail ? selectedTrafficFineDetail.ReportNumber : ''}`" hide-footer>
            <b-overlay :show="detailLoading">
                <traffic-fine-detail :details="selectedTrafficFineDetail" />
            </b-overlay>
        </b-modal>

        <v-table ref="table" name="my-traffic-fine-approvals" :fields="fields" :items="items" :buttons="buttons" with-items />
    </b-card>
</template>

<script>
import { BCard, BModal, BOverlay } from "bootstrap-vue";
import EmployeeOperationsApi from "@/api/employee-operations";
import TrafficFineDetail from "./components/TrafficFineDetail.vue";

export default {
    components: {
        BCard,
        BModal,
        BOverlay,
        TrafficFineDetail,
    },
    data() {
        return {
            items: [],
            selectedTrafficFineDetail: null,
            detailLoading: false,
            fields: [
                { name: "Tutanak Numarası", key: "RefNumber", thClass: "w-20", sortable: false },
                { name: "Personel", key: "EmployeeFullName", thClass: "w-40", sortable: false },
                { name: "Hareket Tarihi", key: "ActionDateStr", thClass: "w-20", sortable: false },
                {
                    name: "Durum",
                    key: "ApprovalStatus",
                    thClass: "w-20",
                    sortable: false,
                    tdClass: "text-center",
                    component: true,
                    componentOptions: { name: "traffic-fine/TrafficFineApprovalStatusBadge" },
                },
            ],
            approveOrRejectData:{
                title:'',
                description:'',
                approve: null,
                ApprovalStatusId:null
            },
            approveOrRejecting:false,
            buttons: [
                { text: "İncele", key: "view", icon: "EyeIcon", variant: "primary", action: this.viewDetails },
                { text: "Onayla", key: "approve", icon: "CheckIcon", variant: "success", action: this.approve },
                { text: "Reddet", key: "reject", icon: "XIcon", variant: "danger", action: this.reject }
            ],
        };
    },
    mounted() {
        this.fetchMyApprovals();
    },
    methods: {
        fetchMyApprovals() {
            this.$refs.table.setLoading(true);
            EmployeeOperationsApi.TrafficFine.myApprovals()
                .then((res) => {
                    this.items = res.data.Data || [];
                })
                .finally(() => {
                    this.$refs.table.setLoading(false);
                });
        },
        approve(item){
            this.approveOrRejectData.ApprovalStatusId = item.ApprovalStatusId
            this.approveOrRejectData.title = 'Onayla'
            this.approveOrRejectData.approve = true
            this.approveOrRejectData.description = ''
            this.$showModal('description')
        },
        reject(item){
            this.approveOrRejectData.ApprovalStatusId = item.ApprovalStatusId
            this.approveOrRejectData.title = 'Reddet'
            this.approveOrRejectData.approve = false
            this.approveOrRejectData.description = ''
            this.$showModal('description')
        },
        approveOrReject(){
            this.approveOrRejecting = true
            EmployeeOperationsApi.TrafficFine.ChangeApprovalStatus(
                this.approveOrRejectData.ApprovalStatusId,
                this.approveOrRejectData.approve,
                this.approveOrRejectData.description
            ).then(res => {
                if(res.data.Success){
                    this.fetchMyApprovals()
                    this.$hideModal('description')
                }
                this.approveOrRejecting = false
                this.$result(res)
            }).catch(err => {
                this.approveOrRejecting = false
                this.$result(null,err)
            })
        },
        viewDetails(item) {
            this.selectedTrafficFineDetail = null;
            this.detailLoading = true;
            this.$bvModal.show("view-traffic-fine-detail-modal");

            EmployeeOperationsApi.TrafficFine.Get(item.EmployeeTrafficFineId)
                .then((res) => {
                    if (res.data.Success) {
                        this.selectedTrafficFineDetail = res.data.Data;
                    } else {
                        this.$result(res);
                        this.$bvModal.hide("view-traffic-fine-detail-modal");
                    }
                })
                .finally(() => {
                    this.detailLoading = false;
                });
        },
    },
};
</script>
